/**
 * Déconnexion propre (même règle que GameTime/session.js) :
 * NE PAS naviguer vers /login depuis un écran /home/* (routeur interne Ionic).
 * On se contente de signOut() : le guard de App.tsx redirige vers /login dès
 * que l'utilisateur devient null, depuis n'importe quel écran.
 */
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export async function logout(): Promise<void> {
  try {
    localStorage.removeItem("st_profile_cache");
  } catch (e) {
    /* stockage indisponible */
  }
  await signOut(auth);
}
